export default {
  title: {
    'zh-cn': '视频矩阵',
    'zh-tw': '視頻矩陣',
    'en': 'Video Matrix'
  },
  // 对话框
  selectPlayDevice: {
    'zh-cn': '选择播放设备',
    'zh-tw': '選擇播放設備',
    'en': 'Select Play Device'
  },
  // 表单标签
  deviceSN: {
    'zh-cn': '设备SN',
    'zh-tw': '設備SN',
    'en': 'Device SN'
  },
  status: {
    'zh-cn': '状态',
    'zh-tw': '狀態',
    'en': 'Status'
  },
  // 占位符
  pleaseInput: {
    'zh-cn': '请输入',
    'zh-tw': '請輸入',
    'en': 'Please input'
  },
  pleaseSelect: {
    'zh-cn': '请选择',
    'zh-tw': '請選擇',
    'en': 'Please select'
  },
  // 表格列
  serialNumber: {
    'zh-cn': '序号',
    'zh-tw': '序號',
    'en': 'No.'
  },
  deviceType: {
    'zh-cn': '设备类型',
    'zh-tw': '設備類型',
    'en': 'Device Type'
  },
  belongGroup: {
    'zh-cn': '所属分组',
    'zh-tw': '所屬分組',
    'en': 'Belong Group'
  },
  channel: {
    'zh-cn': '通道',
    'zh-tw': '通道',
    'en': 'Channel'
  },
  authStatus: {
    'zh-cn': '认证状态',
    'zh-tw': '認證狀態',
    'en': 'Auth Status'
  },
  firmwareVersion: {
    'zh-cn': '固件版本',
    'zh-tw': '固件版本',
    'en': 'Firmware Version'
  },
  appVersion: {
    'zh-cn': 'APP版本',
    'zh-tw': 'APP版本',
    'en': 'APP Version'
  },
  lastOnlineTime: {
    'zh-cn': '最后上线时间',
    'zh-tw': '最後上線時間',
    'en': 'Last Online Time'
  },
  lastOfflineTime: {
    'zh-cn': '最后离线时间',
    'zh-tw': '最後離線時間',
    'en': 'Last Offline Time'
  },
  remark: {
    'zh-cn': '备注',
    'zh-tw': '備註',
    'en': 'Remark'
  }
}

